function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderWidget)?_c('component',_vm._b({attrs:{"data":_vm.data},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var widget = ref.data;
var widgetSpaceLeft = ref.spaceLeft;
var rest = objectWithoutProperties( ref, ["data", "spaceLeft"] );
var widgetProps = rest;
return [(widget)?_c('Widget',{attrs:{"data":widget,"spaceLeft":widgetSpaceLeft || _vm.spaceLeft,"widgetProps":widgetProps}}):_vm._e()]}}],null,false,2419165065)},'component',_vm.wrapperOptions,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }